import { inject, Injectable } from '@angular/core';
import { selectEntity, upsertEntities } from '@ngneat/elf-entities';
import { ResultService } from '@thiememeulenhoff/ng-api-gateway';
import { map, tap } from 'rxjs';
import { BulkDeleteCollection, GroupResult } from '@thiememeulenhoff/types';
import * as stores from './result.store';

@Injectable({
  providedIn: 'root',
})
export class ResultFacade {
  readonly #groupResults = stores.groupResults;

  readonly #resultService = inject(ResultService);

  readonly groupResult$ = (
    groupCode: string,
    arrangementCode: string,
    contentIdentifier: string,
  ) =>
    this.#groupResults.pipe(
      selectEntity(
        this.#groupResultIdentifier(
          groupCode,
          arrangementCode,
          contentIdentifier,
        ),
      ),
    );

  fetchGroupResult(
    groupCode: string,
    arrangementCode: string,
    contentIdentifier: string,
    showTeachers: boolean,
  ) {
    return this.#resultService
      .fetchGroupResult(
        groupCode,
        arrangementCode,
        contentIdentifier,
        showTeachers,
      )
      .pipe(
        map((groupResult: GroupResult) => {
          return {
            ...groupResult,
            identifier: this.#groupResultIdentifier(
              groupCode,
              arrangementCode,
              contentIdentifier,
            ),
          } as GroupResult;
        }),
        tap((groupResult: GroupResult) => {
          this.#upsertGroupResult(groupResult);
        }),
      );
  }

  deleteGroupResult(groupCode: string, collection: BulkDeleteCollection) {
    return this.#resultService.bulkDeleteGroupResult(groupCode, collection);
  }

  #upsertGroupResult(groupResult: GroupResult) {
    this.#groupResults.update(upsertEntities([groupResult]));
  }

  // eslint-disable-next-line class-methods-use-this
  #groupResultIdentifier(
    groupCode: string,
    arrangementCode: string,
    contentIdentifier: string,
  ): string {
    return `${groupCode}_${arrangementCode}_${contentIdentifier}`;
  }
}
